import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * SEO helper — wraps react-helmet-async with sensible defaults for Vedacosmos.
 */
export default function SEO({
  title = "Vedacosmos — Ancient Wisdom. Modern Technology.",
  description = "The Vedic super app — Auto AI Kundali, live astrologers, pandit booking, spiritual marketplace, LMS, and daily horoscope. Reimagined for 2026.",
  image = "https://images.unsplash.com/photo-1518998053901-5348d3961a04?w=1200",
  path = "",
}) {
  const url = `https://vedacosmos.com${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="vedacosmos, astrology, kundali, tarot, numerology, vastu, pandit booking, spiritual, hindu, vedic, ai horoscope, rudraksha, yantra" />
      <link rel="canonical" href={url} />

      {/* OpenGraph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Vedacosmos" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Vedacosmos",
        "url": "https://vedacosmos.com",
        "logo": "https://vedacosmos.com/logo.png",
        "description": description,
        "sameAs": ["https://instagram.com/vedacosmos", "https://youtube.com/vedacosmos"],
      })}</script>
    </Helmet>
  );
}
